import Tag from "../components/tag/Tag";

function Skills (){
  return (
    <div className="app">
      <div className="skills">
        <Tag/> 
      </div>
    </div>
);}

export default Skills;